var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSourceBooking = function SvgSourceBooking(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#8290A2",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833496 4.5835C0.833496 3.4329 1.76624 2.50016 2.91683 2.50016H17.0835C18.2341 2.50016 19.1668 3.4329 19.1668 4.5835V17.0835C19.1668 18.2341 18.2341 19.1668 17.0835 19.1668H2.91683C1.76624 19.1668 0.833496 18.2341 0.833496 17.0835V4.5835ZM2.91683 4.16683C2.68671 4.16683 2.50016 4.35338 2.50016 4.5835V17.0835C2.50016 17.3136 2.68671 17.5002 2.91683 17.5002H17.0835C17.3136 17.5002 17.5002 17.3136 17.5002 17.0835V4.5835C17.5002 4.35338 17.3136 4.16683 17.0835 4.16683H2.91683Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25016 0.833496C6.7104 0.833496 7.0835 1.20659 7.0835 1.66683V5.00016C7.0835 5.4604 6.7104 5.8335 6.25016 5.8335C5.78993 5.8335 5.41683 5.4604 5.41683 5.00016V1.66683C5.41683 1.20659 5.78993 0.833496 6.25016 0.833496Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7502 0.833496C14.2104 0.833496 14.5835 1.20659 14.5835 1.66683V5.00016C14.5835 5.4604 14.2104 5.8335 13.7502 5.8335C13.2899 5.8335 12.9168 5.4604 12.9168 5.00016V1.66683C12.9168 1.20659 13.2899 0.833496 13.7502 0.833496Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 10.8335C10.6905 10.8335 11.2502 10.2739 11.2502 9.5835C11.2502 8.89314 10.6905 8.3335 10.0002 8.3335C9.30981 8.3335 8.75016 8.89314 8.75016 9.5835C8.75016 10.2739 9.30981 10.8335 10.0002 10.8335Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5835 10.8335C15.2739 10.8335 15.8335 10.2739 15.8335 9.5835C15.8335 8.89314 15.2739 8.3335 14.5835 8.3335C13.8931 8.3335 13.3335 8.89314 13.3335 9.5835C13.3335 10.2739 13.8931 10.8335 14.5835 10.8335Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41683 15.4168C6.10718 15.4168 6.66683 14.8572 6.66683 14.1668C6.66683 13.4765 6.10718 12.9168 5.41683 12.9168C4.72647 12.9168 4.16683 13.4765 4.16683 14.1668C4.16683 14.8572 4.72647 15.4168 5.41683 15.4168Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 15.4168C10.6905 15.4168 11.2502 14.8572 11.2502 14.1668C11.2502 13.4765 10.6905 12.9168 10.0002 12.9168C9.30981 12.9168 8.75016 13.4765 8.75016 14.1668C8.75016 14.8572 9.30981 15.4168 10.0002 15.4168Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSourceBooking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source-booking.1e9876b9.svg";
export { ForwardRef as ReactComponent };